import React, {createContext, useContext} from 'react';

export const FormContext = createContext();

export const FormProvider = ({form, schema, children}) => (
	<FormContext.Provider value={{form, schema}}>{children}</FormContext.Provider>
);

export const useFormContext = () => useContext(FormContext);
